export default __webpack_public_path__ + "static/media/order-step2.43c894ae.svg";